export default __webpack_public_path__ + "static/media/editImageIcon.236a1384.svg";